/**
 * Tag Page
 * Lists posts that use a given hashtag (/tag/:tag).
 */

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import SinglePostDisplay from '../components/post/SinglePostDisplay';

const TagPage = () => {
  const { tag } = useParams();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/posts/tag/${encodeURIComponent(tag)}`);
      setPosts(res.data);
    } catch (error) {
      console.error('Error fetching tagged posts:', error);
    } finally {
      setLoading(false);
    }
  }, [tag]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  return (
    <div className="container">
      <Link to="/feed" className="back-link">← Back to feed</Link>
      <h1>#{tag}</h1>
      {loading ? (
        <div className="loading">Loading...</div>
      ) : posts.length === 0 ? (
        <div className="no-posts"><p>No posts with #{tag} yet.</p></div>
      ) : (
        <div className="posts-list">
          {posts.map((post) => (
            <SinglePostDisplay key={post._id} post={post} onUpdate={fetchPosts} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TagPage;
